import { postAPI } from "../api/api"
import { ModalButton } from "../atoms/buttons"
import { TextAtom } from "../atoms/TextAtom"
import { HorizontalLayout, VerticalLayout } from "../components/layout"

export const Receipt = ({ details, total_new, total_old }) => {
    console.log("receipt details",details)
    return (
        <VerticalLayout className={"feature-card receipt-feature"}>
            <TextAtom title="Invoice" className={"feature-title"} />
            {total_new > 0 && <ReceiptDetail detail={{ "name": "Accounts", description: "Nieuwe gebruikers", price: 7.5 }} accounts={total_new} />}
            {total_old > 0 && details.map((detail, index) => (
                <ReceiptOldDetail key={index} detail={detail} accounts={total_old} />
            ))}
            {total_new > 0 && details.map((detail, index) => (
                <ReceiptDetail key={index} detail={detail} accounts={total_new} />
            ))}
            <ReceiptTotal list_feature={details} new_users={total_new} old_users={total_old} />
        </VerticalLayout>
    )
}

const ReceiptDetail = ({ detail, accounts }) => {
    return (
        <HorizontalLayout className="space-between receipt-detail" style={{ width: "unset" }} >
            <TextAtom className={"receipt-detail-text"} title={`Nieuwe gebruikers: ${detail.name} (${accounts} x ${Math.round((detail.price  + Number.EPSILON) * 100) / 100} euro) / maand`} />
            <TextAtom title={`${detail.price * accounts} euro`} />
        </HorizontalLayout>
    )
}
const ReceiptOldDetail = ({ detail, accounts }) => {
    return (
        <HorizontalLayout className="space-between receipt-detail" style={{ width: "unset" }} >
            <TextAtom className={"receipt-detail-text"} title={`Huidige gebruikers: ${detail.name} (${accounts} x ${Math.round((detail.price + Number.EPSILON) * 100) / 100} euro) / maand`} />
            <TextAtom title={`${detail.price * accounts} euro`} />
        </HorizontalLayout>
    )
}

const ReceiptTotal = ({ list_feature, new_users, old_users }) => {
    const confirmPurchase = () => {
        buyFeatures()
    }
    const buyFeatures = async (data) => {
        const body = {
            new_users: new_users,
            features:list_feature,
            total_value:total_value(list_feature, new_users, old_users) * 12 
        }
        const buy = await postAPI('api/orders/buy-extra',body)
        if (buy.status === "succes") {
            console.log("yeah")
        }
    }
    const total_value = (list_feature, new_users, old_users) => {
        var total = 0
        console.log(list_feature)
        list_feature.forEach(feature => {
            if (feature.checked) {
                console.log(feature.new_price)
                total += (feature.new_price * new_users)
            }
            if (feature.checked && feature.owned) {
                total += + (feature.price * old_users)
            }
        })
        total += new_users * 7.5
        return total
    }

    return (
        <VerticalLayout className="receipt-total">

            <HorizontalLayout className="space-between receipt-total-text">
                <TextAtom title={"Totaal"} className="semi-bold" />
                <TextAtom title={total_value(list_feature, new_users, old_users) * 12  + " euro / jaar"} className="semi-bold" />
            </HorizontalLayout>
            <ModalButton
                title={"Bevestig aankoop"}
                onClick={confirmPurchase}

            />
        </VerticalLayout>
    )
}